import { Arr } from '../../lib/Array.lib';
import { Str } from '../../lib/String.lib';

export default function mapStringsArrayToTagObjectArray(array) {
  return Arr(array).map(v => ({ id: Str(v), label: Str(v) }));
}
